const journeysQueryKeys = {
    journeyList: 'journeyList'
}

export default journeysQueryKeys;
